import React from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { FORM_ITEM } from '@/typings/reducer';
import { setformtip } from '@/redux/index/action';

function index(): JSX.Element {
    const dispatch = useDispatch();
    const {
        base_config: { form_setting },
        sess_id
    } = useSelector(
        ({ IndexReducer, IMReducer }) => ({
            base_config: IndexReducer.base_config,
            sess_id: IMReducer.sess_id
        }),
        shallowEqual
    );
    const _handleSelectForm = async (item: FORM_ITEM) => {
        const { form_key } = item;
        const token = await IM.InitServer.getFormToken({ refer: 1, type: form_key });
        if (!token) return;
        IM.SDKServer.openFormView({ type: form_key, token, sess_id });
    };
    const _handleFormProgress = async () => {
        const token = await IM.InitServer.getFormToken({ refer: 2 });
        if (!token) return;
        dispatch(setformtip(0));
        IM.SDKServer.openFormProgress({ token });
    };

    return (
        <div className="im-forms">
            <ul>
                {!!form_setting.entrance && (
                    <li onClick={_handleFormProgress}>
                        <span className="item-icon" />
                        反馈进度
                        {!!form_setting.tip && <span className="item-reddot" />}
                    </li>
                )}
                {form_setting.type?.map((item) => (
                    <li onClick={() => _handleSelectForm(item)}>
                        <img src={item.f_icon.full_uri} alt={item.f_icon.file_name} />
                        {item.f_form_key}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default index;
